angular.module('mychart').controller('CcdTransmitModalCtrl',
    ['$scope', '$uibModalInstance', 'ChartRepository', 'requestDto', 'toaster', 'aprgettext', '$log',
        function ($scope, $modalInstance, ChartRepository, requestDto, toaster, gettext, $log) {
            'use strict';

            $scope.loading = true;
            $scope.canSendDirectMail = false;
            $scope.transmitting = false;
            $scope.isConfigured = false;
            $scope.model = {
                DirectMailUser: '',
                DocumentTypeList: [
                    {Type: 'HTML'},
                    {Type: 'XML'}
                ],
                SendTypeList: [
                    {
                        Type: 'Direct Mail',
                        Enabled: false
                    },
                    {
                        Type: 'Email',
                        Enabled: false
                    }
                ],
                DocumentType: '',
                ProviderId: '',
                DirectMailAddressTo: '',
                Email:'',
                SendType: '',
                Subject: '',
                Message: ''
            };

            function initialize() {
                $scope.removeHttpError();
                $scope.model.SendType = $scope.model.SendTypeList[1];
                ChartRepository.getTransferCcdMetadata($scope);
                ChartRepository.getTransmitCcdConfig(requestDto.PatientId)
                    .then(function (data) {
                        if (data && data.DirectMailConfig && data.DirectMailConfig.DirectMailAddress) {
                            $scope.model.DirectMailUser = data.DirectMailConfig;
                            $scope.model.SendTypeList[0].Enabled = true;
                            $scope.model.SendType = $scope.model.SendTypeList[0];
                        }
                        $scope.model.SendTypeList[1].Enabled = data.EmailEnabled;
                        if ($scope.model.SendTypeList[0].Enabled || $scope.model.SendTypeList[1].Enabled) {
                            $scope.isConfigured = true;
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
            initialize();

            function submitTransferRequest() {
                if ($scope.transmitCcdForm.$valid) {
                    $scope.transmitting = true;
                    var transferRequestDto = {
                        PatientId: requestDto.PatientId,
                        LoginUserId: requestDto.LoginUserId,
                        LoginUserName: requestDto.LoginUserName,
                        DocumentType: $scope.model.DocumentType && $scope.model.DocumentType.Type,
                        Subject: $scope.model.Subject,
                        Message: $scope.model.Message,
                        DirectMailAddressFrom: $scope.model.DirectMailUser.DirectMailAddress,
                        ToName: $scope.model.ToName,
                        ProviderId: $scope.model.DirectMailUser.ProviderId,
                        DirectMailAddressTo: ($scope.model.SendType.Type === 'Direct Mail') ? $scope.model.DirectMailAddressTo : null,
                        Email: ($scope.model.SendType.Type === 'Email') ? $scope.model.Email : null,
                        StartDate: requestDto.startDate,
                        EndDate: requestDto.endDate
                    };

                    ChartRepository.postTransmitRequest(transferRequestDto)
                        .then(function (data) {
                            $scope.model.AccessLog = data;
                            toaster.pop('success', '', gettext('CCD was sent successfully.'));
                            ok();
                        })
                        .catch(function (response) {
                            $log.error(response);
                            toaster.pop('error', '', gettext('An error has occurred. CCD was not sent.'));
                        })
                        .finally(function () {
                            $scope.transmitting = false;
                        });
                }
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.submitTransferRequest = submitTransferRequest;
            $scope.ok = ok;
            $scope.cancel = cancel;
        }]);
